import React from 'react';
import { Input, Label, FormGroup } from 'reactstrap';
import Select from 'react-select';
import moment from 'moment';
import UploadIcon from '../../assets/Images/upload-image.svg';

export const renderImageField = ({
  input,
  placeholder,
  className,
  accept,
  controlledValue,
  readOnly,
  autoFocus,
  type,
  id,
  meta: { touched, error, warning },
}) => {
  return (
    <>
      <span className="upload-image">
        <label htmlFor={id} className="upload-image-label form-control">
          Upload image
          <img src={UploadIcon} alt={'not-available'} className="upload-icon" />
        </label>
      </span>
      <Input
        {...input}
        placeholder={placeholder}
        className={className}
        value={controlledValue}
        type={type}
        accept={accept}
        autoFocus={autoFocus}
        readOnly={readOnly}
        invalid={touched && error ? true : false}
        id={id}
        style={{ display: 'none' }}
      />
      <div className="invalid-feedback">
        {touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}
      </div>
    </>
  );
};

export const renderFileField = ({
  input,
  placeholder,
  className,
  controlledValue,
  readOnly,
  autoFocus,
  type,
  id,
  accept,
  meta: { touched, error, warning },
}) => (
  <>
    <span className="upload-image">
      <label htmlFor={id} className="upload-image-label form-control">
        Upload File
        <img src={UploadIcon} alt={'not-available'} className="upload-icon" />
      </label>
    </span>
    <Input
      {...input}
      placeholder={placeholder}
      className={className}
      value={controlledValue}
      type={type}
      autoFocus={autoFocus}
      readOnly={readOnly}
      invalid={touched && error ? true : false}
      required={true}
      id={id}
      style={{ display: 'none' }}
      accept={accept}
    />
    <div className="invalid-feedback">
      {touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}
    </div>
  </>
);

export const renderTextField = ({
  input,
  placeholder,
  className,
  readOnly,
  autoFocus,
  type,
  isDisabled,
  required,
  min,
  max,
  meta: { touched, error, warning },
}) => (
  <>
    <Input
      {...input}
      placeholder={placeholder}
      className={className}
      value={input.value || ''}
      type={type}
      autoFocus={autoFocus}
      readOnly={readOnly}
      invalid={touched && error ? true : false}
      required={required}
      disabled={isDisabled}
      min={min || ''}
      max={max || ''}
    />
    <div className="invalid-feedback">
      {touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}
    </div>
  </>
);

export const renderReactSelectInputField = ({
  input,
  options,
  name,
  id,
  placeholder,
  isClearable,
  isDisabled,
  className,
  isMulti,
  isLoading,
  onMenuOpen,
  onMenuClose,
  meta: { touched, error, warning },
}) => {
  return (
    <>
      <Select
        {...input}
        id={id}
        name={name}
        className={className}
        placeholder={placeholder}
        isClearable={isClearable}
        isDisabled={isDisabled}
        options={options}
        value={input.value || ''}
        onChange={value => input.onChange(value)}
        onBlur={() => input.onBlur(input.value)}
        isMulti={isMulti}
        required={true}
        maxMenuHeight={150}
        isLoading={isLoading}
        onMenuOpen={onMenuOpen}
        onMenuClose={onMenuClose}
      />
      <div className="invalid-feedback">
        {touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}
      </div>
    </>
  );
};
export const renderReactUserInputField = ({
  input,
  options,
  name,
  id,
  type,
  placeholder,
  isClearable,
  isDisabled,
  className,
  isMulti,
  isLoading,
  onMenuOpen,
  onMenuClose,
  meta: { touched, error, warning },
}) => {
  return (
    <>
      <Input
        {...input}
        id={id}
        name={name}
        type={type}
        className={className}
        placeholder={placeholder}
        isClearable={isClearable}
        isDisabled={isDisabled}
        options={options}
        value={input.value || ''}
        onChange={value => input.onChange(value)}
        onBlur={() => input.onBlur(input.value)}
        isMulti={isMulti}
        required={true}
        maxMenuHeight={150}
        isLoading={isLoading}
        onMenuOpen={onMenuOpen}
        onMenuClose={onMenuClose}
        
      />
      <div className="invalid-feedback">
        {touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}
      </div>
    </>
  );
};
export const renderSelectDropdownField = ({
  input,
  placeholder,
  className,
  controlledValue,
  disabled,
  type,
  meta: { touched, error },
  children,
}) => (
  <>
    <div className="field">
      <div className="control">
        <div className={'select ' + (touched ? (error ? 'is-danger' : 'is-success') : '')}>
          <select
            {...input}
            placeholder={placeholder}
            className={className}
            value={controlledValue}
            type={type}
            disabled={disabled}
            required={true}
            invalid={touched && error ? true : false}
          >
            {children}
          </select>
          <div className="invalid-feedback">
            {touched && error && <p className="text-danger select-style">{error}</p>}
          </div>
        </div>
      </div>
    </div>
  </>
);

export const renderDateField = ({
  input,
  placeholder,
  className,
  readOnly,
  autoFocus,
  required,
  meta: { touched, error, warning },
}) => (
  <>
    <Input
      {...input}
      placeholder={placeholder}
      className={className}
      value={input.value ? moment(input.value) : null}
      type="date"
      autoFocus={autoFocus}
      readOnly={readOnly}
      invalid={touched && error ? true : false}
      required={required}
    />
    <div className="invalid-feedback">
      {touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}
    </div>
  </>
);

export const renderFileInput = () => {
  return (
    <FormGroup>
      <Label htmlFor="exampleFile">File</Label>
      <Input type="file" name="file" id="exampleFile" />
    </FormGroup>
  );
};
